import { CustomRegistrationQuestion } from "../types/RegistrationQuestion";
import { deleteData, getData, postData, putData } from "./apiService";

export const getCustomRegistrationQuestionsForEvent = async (event_id: string): Promise<CustomRegistrationQuestion[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/events/${event_id}/custom-registration-questions`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as CustomRegistrationQuestion[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };


    export const addCustomRegistrationQuestionToEvent = async (event_id: string, question: CustomRegistrationQuestion): Promise<boolean> => {
    try {
      // Call getData with the endpoint and optional parameterscustom_question_text, is_required
      const response = await postData('/custom-registration-questions', {event_id: event_id, custom_question_text: question.custom_question_text, is_required: question.is_required});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return false;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };


  export const addCustomRegistrationQuestionsToEvent = async (event_id: string, questions: CustomRegistrationQuestion[]): Promise<boolean> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData('/custom-registration-questions/set', {event_id: event_id, questions: questions});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return false;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };


  export const deleteCustomRegistrationQuestion = async (event_id: string, question_id: string): Promise<boolean> => {
  try {
    const response = await deleteData(`/custom-registration-questions/${question_id}`, {
      event_id,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to delete custom question:', error);
    return false;
  }
};

export const updateCustomRegistrationQuestion = async (
  event_id: string,
  question: CustomRegistrationQuestion
): Promise<boolean> => {
  try {
    const response = await putData(`/custom-registration-questions/${question.custom_registration_question_id}`, {
      event_id,
      is_required: question.is_required,
      custom_question_text: question.custom_question_text
    });
    return response.success;
  } catch (error) {
    console.error('Failed to update custom question:', error);
    return false;
  }
};